var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow7Down(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 7",
    d: "M2.6337 1.3663C2.28372 1.01631 1.71628 1.01631 1.3663 1.3663C1.01631 1.71628 1.01631 2.28372 1.3663 2.6337L2.6337 1.3663ZM9 9.89619C9.49495 9.89619 9.89619 9.49495 9.89619 9L9.89619 0.934256C9.89619 0.439301 9.49495 0.0380616 9 0.0380618C8.50505 0.0380617 8.10381 0.439301 8.10381 0.934255L8.10381 8.10381L0.934255 8.10381C0.439301 8.10381 0.0380612 8.50505 0.0380612 9C0.038061 9.49495 0.4393 9.89619 0.934255 9.89619L9 9.89619ZM1.3663 2.6337L8.36629 9.6337L9.6337 8.3663L2.6337 1.3663L1.3663 2.6337Z",
    fill: "#FF481F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow7Down);
export default __webpack_public_path__ + "static/media/Arrow 7 down.d2320e511c227dedb6b5f1f51b9e450e.svg";
export { ForwardRef as ReactComponent };